import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitComponent, FastClick, ResetSearchAccessor, renderComponent } from "../../../../../core";

var defaults = require("lodash/defaults");

export var ResetFiltersDisplay =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ResetFiltersDisplay, _React$PureComponent);

  function ResetFiltersDisplay() {
    _classCallCheck(this, ResetFiltersDisplay);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResetFiltersDisplay).apply(this, arguments));
  }

  _createClass(ResetFiltersDisplay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bemBlock = _this$props.bemBlock,
          hasFilters = _this$props.hasFilters,
          resetFilters = _this$props.resetFilters,
          clearAllLabel = _this$props.clearAllLabel;
      return React.createElement("div", null, React.createElement(FastClick, {
        handler: resetFilters
      }, React.createElement("div", {
        className: bemBlock().state({
          disabled: !hasFilters
        })
      }, React.createElement("div", {
        className: bemBlock("reset")
      }, clearAllLabel))));
    }
  }]);

  return ResetFiltersDisplay;
}(React.PureComponent);
export var ResetFilters =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(ResetFilters, _SearchkitComponent);

  function ResetFilters(props) {
    var _this;

    _classCallCheck(this, ResetFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResetFilters).call(this, props));
    _this.translations = ResetFilters.translations;
    _this.resetFilters = _this.resetFilters.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ResetFilters, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      return {
        container: this.props.mod || "sk-reset-filters"
      };
    }
  }, {
    key: "defineAccessor",
    value: function defineAccessor() {
      return new ResetSearchAccessor(this.props.options);
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.accessor.performReset();
      this.searchkit.performSearch();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var props = {
        bemBlock: this.bemBlocks.container,
        resetFilters: this.resetFilters,
        hasFilters: this.accessor.canReset(),
        translate: this.translate,
        clearAllLabel: this.translate("reset.clear_all")
      };
      return renderComponent(this.props.component, props);
    }
  }]);

  return ResetFilters;
}(SearchkitComponent);
ResetFilters.translations = {
  "reset.clear_all": "Clear all filters"
};
ResetFilters.propTypes = defaults({
  translations: SearchkitComponent.translationsPropType(ResetFilters.translations),
  component: PropTypes.func,
  options: PropTypes.object
}, SearchkitComponent.propTypes);
ResetFilters.defaultProps = {
  component: ResetFiltersDisplay
};